module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABmSURBVFiF7ZbBDYAwDAMbJutoYbKymXkAQvRVoTYuwrfAneRHkpL4AgAybpwR4HhCiaiJjahmUIQirpCiiJkjiiJa5lgCmrYAxwF1gtnkLvloMe8YSf4/+Rkw7C1/cwtWM+sWIOjsiL3puPkqrxsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right.png
// module id = vC+O
// module chunks = 0